import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Task} from '../../../entities/Task';
import {Job} from '../../../entities/Job';
import {TaskService} from '../../../services/task.service';
import {JobService} from '../../../services/job.service';
import {LoginService} from '../../../services/login.service';
import {Customer} from '../../../entities/Customer';
import {CustomerService} from '../../../services/customer.service';
import {Responsible} from '../../../entities/SalesPerson';
import {IMyDateModel, IMyDpOptions} from 'mydatepicker';
import {AppFile} from '../../../entities/AppFile';
import {CreateTaskWithFiles} from '../../../entities/CreateTaskWithFiles';

@Component({
  selector: 'CreateTaskModal',
  templateUrl: './CreateTaskModal.component.html',
  styleUrls: ['./CreateTaskModal.component.css']
})
export class CreateTaskModalComponent implements OnInit {


  _salesPersons: Responsible[] = [];
  _loggedInUser: string = '';
  jobs: Job[] = [];
  fileLoadingDone: boolean = true;

  //salesPerson : Responsible = new Responsible();

  @Output()
  createTaskEmitter = new EventEmitter();
  @Output()
  uploadFilesEmitter = new EventEmitter();
  @Output()
  closingModalEmitter = new EventEmitter();

  private createTaskOpen: boolean;

  @Input('salesPersons')
  set salesPersons(salesPersons: any) {
    if (salesPersons != null) {
      this._salesPersons = Object.assign(this._salesPersons, salesPersons);
    }
    console.log(this._salesPersons);
    //this.salesPerson.Code = this.newTask.Responsible;
  }

  @Input('jobsInput')
  set jobsInput(_jobs: Job[]) {
    if (_jobs != null) {
      this.jobs = Object.assign(this.jobs, _jobs);
    }
  }

  @Input('CreateModalOpenChanged')
  set createModalOpenChanged(value: boolean){
    this.createTaskOpen = value;
  }

  loggedInUser: string;

  @ViewChild('myCreate')
  fileChooserValue: ElementRef;

  newTask: Task = new Task();
  filesToUpload: AppFile[] = [];

  jobInput: Job;
  selectedJob: Job;
  files: AppFile[];


  customers: Customer[];
  customerInput: Customer;
  selectedCustomer: Customer;

  dummyDeadline: any = {
    date: {
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      day: new Date().getDate(),
      dateFormat: 'dd-mm-yyyy'
    }
  };

  public deadlineOptions: IMyDpOptions = {
    dateFormat: 'dd-mm-yyyy',
    //indicateInvalidDate: true
  };
  doneLoading: boolean = true;

  constructor(private taskService: TaskService, private jobService: JobService, private loginService: LoginService, private customerService: CustomerService) {
  }

  ngOnInit() {
    this.getJobs();
    this.customerService.getAllCustomers().subscribe(customers => this.customers = customers);
    this.customerInput = new Customer();
    this.selectedCustomer = new Customer();

    window.addEventListener('keydown', (ev) => {
      if (ev.which == 27) {
        $('#closeBtn').click();
      }
    });
    this.jobInput = new Job();
    this.selectedJob = new Job();
    this.loggedInUser = this.loginService.getLoggedInUserID();

    this.newTask = new Task();
    this.selectedJob = new Job();
    this.jobInput = new Job();

    this.newTask.Responsible = this.loggedInUser.toUpperCase();
  }

  createTask() {
    if (this.newTask.Create_Job) {
      let task: Task = {
        Task_GUID: '{00000000-0000-0000-0000-000000000000}',
        Status: 'Released',
        Title: this.newTask.Title,
        Text: this.newTask.Text,
        Customer_No: this.selectedCustomer.No,
        JobNo: this.selectedJob.No,
        Task_Type: '1',
        Created_By: this.loggedInUser,
        Created_DateTime: new Date().toUTCString(),
        Create_Job: this.newTask.Create_Job,
        Estimate: this.newTask.Estimate,
        Responsible: this.newTask.Responsible,
        To_Be_Done_By: this.newTask.To_Be_Done_By,
        Deadline: this.newTask.Deadline,
        Work_Description: this.newTask.Work_Description,
        Invoiceable: this.newTask.Invoiceable
      };

      if(task.Deadline === undefined){
        task.Deadline = new Date().toUTCString();
      }
      let taskToCreate = new CreateTaskWithFiles();
      taskToCreate.Files = this.filesToUpload;
      taskToCreate.TaskToCreate = task;
      this.createTaskEmitter.emit(taskToCreate);
      this.filesToUpload = [];
    } else {
      let task: Task = {
        Task_GUID: '{00000000-0000-0000-0000-000000000000}',
        Status: 'Released',
        Title: this.newTask.Title,
        Text: this.newTask.Text,
        JobNo: this.selectedJob.No,
        Customer_No: this.selectedJob.Bill_to_Customer_No,
        Task_Type: '1',
        Created_By: this.loggedInUser,
        Created_DateTime: new Date().toUTCString(),
        Create_Job: this.newTask.Create_Job,
        Estimate: this.newTask.Estimate,
        Responsible: this.newTask.Responsible,
        To_Be_Done_By: this.newTask.To_Be_Done_By,
        Deadline: this.newTask.Deadline,
        Work_Description: this.newTask.Work_Description,
        Invoiceable: this.newTask.Invoiceable
      };
      if(task.Deadline === undefined){
        task.Deadline = new Date().toUTCString();
      }
      let taskToCreate = new CreateTaskWithFiles();
      taskToCreate.Files = this.filesToUpload;
      taskToCreate.TaskToCreate = task;
      this.createTaskEmitter.emit(taskToCreate);
      this.filesToUpload = [];

    }

    this.customerInput = new Customer();
    this.selectedCustomer = new Customer();
    this.newTask = new Task();
    this.selectedJob = new Job();
    this.jobInput = new Job();

    /*this.dummyDeadline = {
      date: {
        year: new Date(this.newTask.Deadline).getFullYear(),
        month: new Date(this.newTask.Deadline).getMonth() + 1,
        day: new Date(this.newTask.Deadline).getDate()
      }
    };*/

    this.setOptionsData();

    this.resetView();

  }



  changeJob(jobNo: string) {
    jobNo = jobNo.trim();
    if (jobNo != 'Alle sager') {
      if (this.jobs.filter(x => x.No == jobNo)[0] != null) {
        this.jobService.GetJob(jobNo).subscribe(x => {
          this.selectedJob = x;
        });
      }
    } else {
    }
  }

  changeCustomer(customerNo: string) {
    customerNo = customerNo.trim();
    if (customerNo != 'Alle kunder') {
      if (this.customers.filter(x => x.No == customerNo)[0] != null) {
        this.customerService.getCustomer(customerNo).subscribe(x => {
          this.selectedCustomer = x;
        });
      }
    } else {
    }
  }

  setOptionsData() {
    this.deadlineOptions = {
      dateFormat: 'dd-mm-yyyy',
      showWeekNumbers: true,
      showClearDateBtn: false,
      showTodayBtn: true,
      markCurrentDay: true,
      showInputField: true,
      //disableDateRanges: [{begin: {year: new Date(this.newTask.Deadline).getFullYear(), month: new Date(this.newTask.Deadline).getMonth() + 1, day: new Date(this.newTask.Deadline).getDate() + 1}, end: {year: 2055, month: 11, day: 20}}],
    }

  }

  setDeadline(event: IMyDateModel) {

    this.newTask.Deadline = event.jsdate.toDateString();

    this.setOptionsData();

    //console.log(this.newTask.Deadline);
  }

  resetView() {
    this.dummyDeadline = new Date().toDateString();

    this.newTask.Deadline = this.dummyDeadline;

    this.dummyDeadline = {
      date: {
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        day: new Date().getDate(),
        format: 'dd-mm-yyyy'
      }
    };
    this.newTask.Responsible = this.loggedInUser.toUpperCase();
    this.closingModal();
  }

  getJobs() {
    this.jobService.GetJobs().subscribe(jobs => this.jobs = jobs);
  }

  uploadFiles() {
    this.uploadFilesEmitter.emit(this.filesToUpload);
  }

  uploadFileTemp(file: AppFile){
    this.fileLoadingDone = false;
    this.filesToUpload.push(file);
    this.fileLoadingDone = true;
  }

  closingModal(){
    this.closingModalEmitter.emit();
  }
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/controllers/task-administration/CreateTaskModal/CreateTaskModal.component.ts